import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { handleGetRequest } from '../../services/GetTemplate';

const getStatusLovSlice = createSlice({
    name: "statusLov",
    initialState: {
        isLoading: false,
        data: [],
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(getStatusLov.pending, (state, action) => {
            state.isLoading = true;
        })
        builder.addCase(getStatusLov.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        })
        builder.addCase(getStatusLov.rejected, (state, action) => {
            state.isError = true;
        })
    }
})

export const getStatusLov = createAsyncThunk("getStatusLov", async () => {
    const res = await handleGetRequest(`/configuration/v1/lookups/getStatus/LKP_STATUS:*`);
    return res?.payLoad;
});

export default getStatusLovSlice.reducer